import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import TarifarioAereoContext from '../../../../../contexts/pricing/tarifario/TarifarioAereoContext';
import {
  selectBackgroundMode,
  selectMode,
  selectStatus,
  selectSubMode,
} from '../../../../../features/tarifario/tarifarioSelectors';
import QCXPageTemplate from '../../../../../templates/page/QCXPageTemplate';
import { isLoadingStatus } from '../../../../../utils/store/store-utils';

export default function TarifarioAereoPage({ children }) {
  const status = useSelector(selectStatus);

  const modeSelectors = useMemo(
    () => ({
      selectMode,
      selectSubMode,
      selectBackgroundMode,
    }),
    [selectMode, selectSubMode, selectBackgroundMode]
  );

  const isLoading = useMemo(() => isLoadingStatus(status), [status]);

  const providerData = useMemo(
    () => ({
      status,
      isLoading,
    }),
    [status, isLoading]
  );

  return (
    <TarifarioAereoContext.Provider value={providerData}>
      <QCXPageTemplate contextComponent={TarifarioAereoContext} modeSelectors={modeSelectors}>
        {children}
      </QCXPageTemplate>
    </TarifarioAereoContext.Provider>
  );
}
